module.exports = __webpack_public_path__ + "static/img/30006 (2).9febb4e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30006 (2).webp
// module id = 3dud
// module chunks = 14